@if (!!item()){

  @if (item()!.type === 'item')
  {
    <li (click)="doItemAction($event)" [style.padding-left]="level() * levelPadding + 'px'">
      <a [routerLink]="item()?.url"
         [attr.data-testid]="'nav-' + item()!.id"
         routerLinkActive="active-route"
         class="menu-link flex items-center cursor-pointer p-3 gap-2 rounded-lg transition-colors duration-150 group">
        @if (item()?.svgIcon) {
          <span class="menu-icon text-base w-[1em] h-[1em] bg-current" [style.mask]="'url(' + item()!.svgIcon + ') center / contain no-repeat'"></span>
        } @else if (item()?.icon) {
          <i class="{{item()!.icon}} menu-icon text-base leading-none"></i>
        }
        <span class="font-medium font-['Roboto_Condensed'] text-base leading-tight">{{item()!.title}}</span>
        @if (item()!.badge) {
          <span class="ml-auto h-5 min-w-5 text-xs font-bold font-['Roboto_Condensed'] leading-tight rounded-xl bg-gray-700 text-white px-2 flex items-center justify-center" [style.color]="item()?.badge?.color ?? undefined" [style.background-color]="item()?.badge?.backgroundColor ?? undefined">{{item()?.badge?.title}}</span>
        }
      </a>
    </li>
  }

  @if (item()!.type === 'group')
  {
    <div (click)="toggleGroup()" class="flex items-center cursor-pointer p-3 gap-4 rounded-md text-surface-900 hover:bg-primary-100 active:bg-primary-200 transition-colors duration-150 group">
      <span class="font-semibold text-base leading-tight font-['Roboto_Condensed']">{{item()?.title}}</span>
      <i class="pi pi-angle-down text-base leading-none text-surface-500 ml-auto" [class.rotate-180]="isExpanded()"></i>
    </div>
    <div class="submenu-container" [class.expanded]="isExpanded()">
      <div class="submenu-content">
        <ul class="list-none my-2 flex flex-col gap-1">
          @for (subItem of item()!.children; track subItem) {
            <side-menu-item [item]="subItem" [level]="level() + 1"></side-menu-item>
          }
        </ul>
        <hr class="border-t border-surface-200 my-6" />
      </div>
    </div>
  }
}
